import React, { useState } from 'react';
import { useHistory } from "react-router-dom";

import bent from 'bent';

const CreateRoom = ({user}) => {
    const defaultCreateRoomContent = () => {
        return (
            <div id="roomTitleForm">
                <label>Room Title</label>
                <input type="text" onChange={e => setTitle(e.target.value)} />
                <input type="submit" value="Create Room &gt;" />
            </div>
        )
    }

    const roomCall = bent(`https://${process.env.REACT_APP_API_DOMAIN}/`, 'POST', 'json', 200);
    const history = useHistory();
    const [title, setTitle] = useState('')
    const [createRoomContent, setCreateRoomContent] = useState(defaultCreateRoomContent);

    const contentOnSubmit = async e => {
        e.preventDefault();
        try {
            const room = await roomCall('room/new', {user, title, record:true});
            history.push(`/rooms/${room.room_id}`);
        } catch(err) {
            console.log(err)
            setCreateRoomContent(<div><h2>There was a problem creating the room.</h2><h4>{err.toString()}</h4></div>)
        }
    }

    return (
        <>
        <div className="content">
            <h2>PRE-RECORDED INTV</h2>
            <form onSubmit={contentOnSubmit}>
                {createRoomContent}
            </form>
        </div>
        </>
    )
}

export default CreateRoom;